import React from 'react';
import {
  TextField, Typography, Grid,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import { resourceFormStyle } from '../../css/style';
import {
  notificationsOrderType,
  reportFrequency,
} from '../../data/Constants';
// eslint-disable-next-line import/no-named-as-default, import/no-named-as-default-member
import Dropdown from '../share/Dropdown';

const styles = resourceFormStyle();

const getSelectedOption = (type, dropdownOptions) => {
  let option = '';
  dropdownOptions.forEach((o) => {
    if (o.value === type) {
      option = o;
    }
  });
  return option;
};

function NotificationAndReportsFieldRow({
  type, email, onChange, onAdd, isSales, id, onDeleteRecipient,
}) {
  const dropdownOptions = isSales ? reportFrequency : notificationsOrderType;
  return (
    <Grid
      container
      style={styles.notificationReportRowContainer}
      spacing={24}
    >
      <div style={styles.reportDropdownEmailContainer}>
        <Dropdown
          data={getSelectedOption(type, dropdownOptions)}
          dropdownOptions={dropdownOptions}
          onChange={event => onChange(isSales, 'type', event.target.value, id, dropdownOptions)}
          style={styles.reportDropdown}
          placeholder={isSales ? 'Frequency' : 'Order Type'}
        />
      </div>
      <Typography
        style={styles.reportEmailLabel}
      >
        Email:
      </Typography>
      <div style={styles.reportDropdownEmailContainer}>
        <TextField
          value={email}
          type='email'
          autoComplete='email'
          onChange={event => onChange(isSales, 'email', event.target.value, id)}
          style={styles.reportEmailInput}
          InputProps={{ disableUnderline: true }}
          // eslint-disable-next-line react/jsx-no-duplicate-props
          inputProps={{ style: styles.reportEmailInputProps }}
          placeholder='email'
        />
      </div>
      <div style={styles.deleteIconContainer}>
        <DeleteIcon
          onClick={() => onDeleteRecipient(id, isSales)}
          style={styles.deleteIcon}
        />
      </div>
      <Typography
        style={styles.addMoreText}
        onClick={() => onAdd(isSales)}
      >
        add more
      </Typography>
    </Grid>
  );
}

function NotificationsAndReportsField({
  data, onChange, onAdd, isSales, onDeleteRecipient,
}) {
  return (
    <Grid
      container
    >
      {
        data.map(recipient => (
          <NotificationAndReportsFieldRow
            id={recipient.id}
            type={isSales ? recipient.reportFrequency : recipient.orderType}
            email={recipient.email}
            onChange={onChange}
            onAdd={onAdd}
            isSales={isSales}
            onDeleteRecipient={onDeleteRecipient}
          />
        ))
      }
    </Grid>
  );
}

NotificationAndReportsFieldRow.propTypes = {
  onChange: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onDeleteRecipient: PropTypes.func.isRequired,
  isSales: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
};

NotificationsAndReportsField.propTypes = {
  data: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  onChange: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onDeleteRecipient: PropTypes.func.isRequired,
  isSales: PropTypes.bool.isRequired,
};


export default NotificationsAndReportsField;
